
import { Component, Vue } from "nuxt-property-decorator";
import OilImportTable from "~/components/organisms/table/OilImportTable.vue";
import ContentPageLayout from "~/components/molecules/display/ContentPageLayout.vue";
import { generateMetaTags } from "~/operations/meta-helper-functions";
import type { JumpNavItem } from "~/types/ContentPage";

@Component({
  scrollToTop: true,
  components: {
    ContentPageLayout,
    OilImportTable,
  },
})
export default class Pelletsqualität extends Vue {
  head() {
    return {
      ...generateMetaTags(this.$route.path, "holzpellets-qualitaet"),
      link: [{ rel: "canonical", href: this.$route.path }],
    };
  }

  get jumpNavItems(): JumpNavItem[] {
    return [
      {
        name: "Grundlagen der Holzpellets Qualität",
        title: "Springen Sie zum Bereich für Infos zu: DIN EN ISO 17225-2 Norm",
        href: {
          hash: "#first-anker",
        },
      },
      {
        name: "Premium Holzpellets Qualität",
        title: "Springen Sie zum Bereich für Infos zu: ENplus A1",
        href: {
          hash: "#second-anker",
        },
      },
      {
        name: "Spezielle Veredelungen",
        title: "Springen Sie zum Bereich für Infos zu: Veredelungen",
        href: {
          hash: "#third-anker",
        },
      },
    ];
  }
}
